import _ from 'lodash';
import { createSelector } from 'reselect';
import { getUserMap } from './user-selectors';

const getFollowersState = state => state.followers;
const getIdList = state => getFollowersState(state).idList;
const getMetadata = state => getFollowersState(state).metadata;

export const getFollowers = createSelector([getIdList, getUserMap], (followerIds, users) =>
  _.map(followerIds, followerId => users[followerId])
);

export const getFollowerCount = state => _.get(getMetadata(state), 'count', 0);



// WEBPACK FOOTER //
// ./app/selectors/followers-selectors.js